module.exports = __webpack_public_path__ + "static/img/linianlogo.19af360a.png";